import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import sambaTheme from './theme';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import dayjs from 'dayjs';
import { Chip } from '@mui/material';

const getColorForChannel = (ch: string, idx: number): string => {
  const hue = (idx * 360 / 24) % 360; // 24 = max channels you expect
  return `hsl(${hue}, 70%, 50%)`;
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <ThemeProvider theme={sambaTheme}>
        <App />
      </ThemeProvider>
    </LocalizationProvider>
  </React.StrictMode>
); 